import controller from './kform-tab-repre.controller';
import template from './kform-tab-repre.html';

export default {
	template,
	controller,
	bindings: {
		disabled:   '<?ngDisabled',
		form:       '<',
		kid:        '<',
	},
	require: {
		kform:   '^^?kform',
	},
};
